module.exports = __webpack_public_path__ + "img/playbutton27.93f5dd20.png";